<template>
  <div
    id="context-menu"
    v-show="menuShown"
    @contextmenu.prevent
  >
    <ul v-if="isContextOnCanvas" @click="close(false, $event)">
      <li class="process" v-if="isSpaceSelected" @click="$emit('copySpace')"><i class='bx bx-copy'></i>コピー (Ctrl+C)</li>
      <li class="process" v-if="isSpaceCopied" @click="$emit('pasteSpace')"><i class='bx bx-paste'></i>貼り付け (Ctrl+V)</li>
      <li class="process" v-if="isSpaceSelected" @click="$emit('deleteSpace')"><i class='bx bx-trash'></i>削除 (Delete)</li>
      <hr v-if="isSpaceSelected || isSpaceCopied"/>
      <li class="radio" v-for="(selectMode, idx) in selectModeList" :key="selectMode.code">
        <input type="radio" :id="'select-mode-' + idx" :value="selectMode.code" :disabled="opeMode.selectObject === 'TYPE_OBJ_CELL'" v-model="opeMode.selectMode" @change="$emit('onSelectModeChanged')">
        <label :for="'select-mode-' + idx">{{ selectMode.label }}選択モード</label>
      </li>
      <hr />
      <li class="checkbox">
        <input type="checkbox" id="rect-select" value="true" v-model="opeMode.rectSelect" @change="$emit('setOpeMode')" />
        <label for="rect-select">矩形選択モード</label>
      </li>
      <hr />
      <li class="checkbox">
        <input type="checkbox" id="face-distance-disp" value="true" v-model="opeMode.faceDistanceDisp" @change="$emit('changeFaceDistanceMode', true)" />
        <label for="face-distance-disp">面間距離を表示</label>
      </li>
      <li class="checkbox">
        <input type="checkbox" id="face-distance-move" value="true" v-model="opeMode.faceDistanceMove" @change="$emit('changeFaceDistanceMode', false)" />
        <label for="face-distance-move">面間距離を指定して移動</label>
      </li>
      <hr />
      <li class="process" v-if="isSelectedOneRelatedToShelfOnCanvas" @click="$emit('showSetCellRatioModal')">セル比率設定</li>
      <hr v-if="isSelectedOneRelatedToShelfOnCanvas" />
      <li class="process" v-if="isDoorSelected" @click="$emit('showSetDoorWrapModal')"><i class='bx bx-layer'></i>かぶせ設定</li>
      <li class="process" v-if="!(isCabinetSelectedForColor || isCombineSelectedForColor || isSetplanSelectedForColor || isSurfaceSelectedForColor) && isDoorSelected" @click="$emit('showSetColorModal')"><i class='bx bx-wrench'></i>カラー設定</li>
      <hr v-if="isDoorSelected" />
      <li class="process" v-if="isOneSelected && (isCabinetSelected || isCombineSelected || isSurfaceSelected || isRuledSetplanSelected)" @click="$emit('showSetSizeModal')"><i class='bx bx-wrench'></i>サイズ設定</li>
      <li class="process" v-if="(isSetMovingSpace || isCabinetMultiSelected)" @click="$emit('showSetMovingModal')"><i class='bx bx-wrench'></i>移動設定</li>
      <li class="process" v-if="(isCabinetSelectedForColor || isCombineSelectedForColor || isSetplanSelectedForColor || isSurfaceSelectedForColor) && !isDoorSelected" @click="$emit('showSetColorModal')"><i class='bx bx-wrench'></i>カラー設定</li>
      <li class="process" v-if="isPtSel" @click="$emit('showSetSelectPartsModal')"><i class='bx bx-wrench'></i>選択パーツ設定</li>
      <li class="process" v-if="isPtMove" @click="$emit('showPartsFacerelationModal')"><i class='bx bx-wrench'></i>指定パーツ位置設定</li>
      <li class="process" v-if="isMobileShelfSelected" @click="$emit('showPosRuleModal')"><i class='bx bx-wrench'></i>加工ルール</li>
      <li class="process" v-if="isOneSelected && isSurfaceSelected" @click="$emit('showSurfaceLedgeModal')"><i class='bx bx-wrench'></i>カウンター/サーフェス収まり設定</li>
      <li class="process" v-if="isSpPrice && isOneUnitSelected" @click="$emit('showCustomPriceModal')"><i class='bx bx-wrench'></i>特注価格設定</li>
      <li class="process" v-if="isOneUnitSelected" @click="$emit('showCustomCommentModal')"><i class='bx bx-wrench'></i>任意コメント設定</li>
      <hr v-if="isSetMovingSpace || isCabinetSelected || isCombineSelected || isSurfaceSelected || isPtSel" />
      <li class="process" v-if="isCabinetMultiSelected" @click="$emit('resizeSpacesEven')">水平方向に均等リサイズ</li>
      <hr v-if="isCabinetMultiSelected" />
      <li class="process" v-if="isCabinetMultiSelected" @click="$emit('addSetPlan')">セットプラン化(固定)</li>
      <li class="process" v-if="isRuledSetTargetSelected" @click="$emit('addRuledSetPlan')">セットプラン化(ルール付き)</li>
      <hr v-if="isCabinetMultiSelected || isRuledSetTargetSelected" />
      <li v-if="isOneSkeltonSelected" class="process" @click="$emit('addCombine')">コンバイン化</li>
      <hr v-if="isOneSkeltonSelected">
      <li v-if="isOneCombineSelected" class="process" @click="$emit('decomposeSpace', true)">コンバインを分解</li>
      <hr v-if="isOneCombineSelected"/>
      <li v-if="isOneSetPlanSelected" class="process" @click="$emit('decomposeSpace', false)">セットプランを分解</li>
      <li v-if="isOneSetPlanSelected" class="process" @click="$emit('decomposeSpace', false, true)">セットプランを一括分解</li>
      <hr v-if="isOneSetPlanSelected"/>
      <li class="process" @click="$emit('setSectionPositionSelectingOn', 'X')">断面線(x)の位置設定</li>
      <li class="process" @click="$emit('setSectionPositionSelectingOn', 'Y')">断面線(y)の位置設定</li>
      <hr />
      <!-- <li class="checkbox">
        <input type="checkbox" id="outside-room" value="true" v-model="opeMode.outsideRoom" @change="$emit('setOpeMode')" />
        <label for="outside-room">部屋の外には配置しない</label>
      </li>
      <hr /> -->
      <li class="process" v-if="isPlanning" @click="$emit('addSheetSection', 'X')">図面断面線(x)の追加</li>
      <li class="process" v-if="isPlanning" @click="$emit('addSheetSection', 'Y')">図面断面線(y)の追加</li>
      <!-- TODO バグがあるため一旦閉じる -->
<!--      <li class="process" v-if="isPlanning" @click="$emit('addSheetSection', 'Z')">図面断面線(奥行)の追加</li>-->
      <hr v-if="isPlanning" />
      <li class="process" v-if="isPlanning && sectionPoint != null" @click="$emit('removeSheetSection', sectionPoint)">断面線を削除</li>
      <hr v-if="isPlanning && sectionPoint != null" />
      <li class="process" @click="$emit('selectAllSpace')">全て選択する</li>
      <hr />
      <li class="process" @click="$emit('resetView')">ビューを初期化する</li>
    </ul>
    <ul v-else @click="close(false, $event)">
      <li v-if="isFocusedOneRelatedToShelf" class="process" @click="$emit('showSetCellRatioModal')"><i class='bx bx-wrench'></i>セル比率設定</li>
      <li v-if="isFocusedParts || isFocusedPartsParent" class="process" @click="$emit('showSetColorModal')"><i class='bx bx-wrench'></i>カラー設定</li>
      <li v-if="isFocusedUnit" class="process" @click="$emit('showSetSelectPartsModal')"><i class='bx bx-wrench'></i>選択パーツ設定</li>
      <li v-if="isFocusedUnit" class="process" @click="$emit('showPartsFacerelationModal')"><i class='bx bx-wrench'></i>指定パーツ位置設定</li>
      <li v-if="isKakoDt && isFocusedParts" class="process" @click="$emit('showFaceOptionModal')"><i class='bx bx-wrench'></i>加工データ</li>
      <li v-if="isFocusedMobileShelfParts" class="process" @click="$emit('showPosRuleModal')"><i class='bx bx-wrench'></i>加工ルール</li>
      <li v-if="isFocusedParts || isFocusedPartsParent" class="process" @click="$emit('showElGrainModal')"><i class='bx bx-wrench'></i>木目設定</li>
      <li v-if="isFocusedParts" class="process" @click="$emit('showMaterialModal')"><i class='bx bx-wrench'></i>素材空間設定</li>
      <li v-if="isFocusedSurface" class="process" @click="$emit('showSurfaceLedgeModal')"><i class='bx bx-wrench'></i>カウンター/サーフェス収まり設定</li>
      <li v-if="isSpPrice && isFocusedUnit" class="process" @click="$emit('showCustomPriceModal')"><i class='bx bx-wrench'></i>特注価格設定</li>
      <li v-if="isFocusedUnit" class="process" @click="$emit('showCustomCommentModal')"><i class='bx bx-wrench'></i>任意コメント設定</li>
      <li v-if="isFocusedUmcodeSpace" class="process" @click="$emit('showUpdateByUmcodeModal')"><i class='bx bx-wrench'></i>アップデート</li>
    </ul>
  </div>
</template>

<script>
import * as App from '../../../utils/App'
import {OBJECT_TYPE, SELECT_MODE, PLANNING_TYPE, OBJECT_DTL_TYPE} from '../../../constants/Type'

export default {
  name: 'ContextMenu',
  props: {
    isSpaceSelected: Boolean,
    isSpaceCopied: Boolean,
    isCabinetMultiSelected: Boolean,
    isRuledSetTargetSelected: Boolean,
    isOneSkeltonSelected: Boolean,
    isOneCombineSelected: Boolean,
    isOneSetPlanSelected: Boolean,
    isSelectedOneRelatedToShelfOnCanvas: Boolean,
    isOneUnitSelected: Boolean,
    isDoorSelected: Boolean,
    isPlanning: Boolean,
    isFocusedUnit: Boolean,
    isFocusedParts: Boolean,
    isFocusedPartsParent: Boolean,
    isFocusedSurface: Boolean,
    isFocusedMobileShelfParts: Boolean,
    isFocusedUmcodeSpace: Boolean,
    isFocusedOneRelatedToShelf: Boolean,
    /** 操作モード */
    opeMode: Object,
    /** キャビネット・インフィル/扉・引出し選択モードリスト */
    selectModeList: Array,
    /** 編集操作用空間データ */
    editCtrlSpaces: Array,
    editChildrenDoor: null,
    /** アクティブな断面位置 */
    activeSectionPoint: Number
  },
  data () {
    return {
      menuShown: false,
      sectionPoint: null,
      isContextOnCanvas: true
    }
  },
  computed: {
    isOneSelected: function () {
      return this.editCtrlSpaces && this.editCtrlSpaces.length === 1
    },
    isCabinetSelected: function () {
      return this.isSpaceSelected && this.opeMode.selectMode === SELECT_MODE.CABINET.code &&
              this.opeMode.selectObject === OBJECT_TYPE.UNIT.code && this.editCtrlSpaces[0].planningType === PLANNING_TYPE.UNIT_SKELTON
    },
    isCombineSelected: function () {
      return this.isSpaceSelected && this.opeMode.selectMode === SELECT_MODE.CABINET.code &&
              this.opeMode.selectObject === OBJECT_TYPE.UNIT.code && this.editCtrlSpaces[0].planningType === PLANNING_TYPE.COMBINE
    },
    isSurfaceSelected: function () {
      return this.isSpaceSelected && this.opeMode.selectMode === SELECT_MODE.CABINET.code &&
              this.opeMode.selectObject === OBJECT_TYPE.UNIT.code && this.editCtrlSpaces[0].planningType === PLANNING_TYPE.UNIT_SURFACE
    },
    isMobileShelfSelected: function () {
      return this.isSpaceSelected && this.opeMode.selectMode === SELECT_MODE.DOOR_DRAWER_INFILL.code &&
              this.opeMode.selectObject === OBJECT_TYPE.UNIT.code && this.editCtrlSpaces[0].spaceObjectDtlType === OBJECT_DTL_TYPE.UNIT_MOBILE_SHELF.code
    },
    isRuledSetplanSelected: function () {
      return this.isOneSetPlanSelected && this.editCtrlSpaces[0].spaceObjectType === OBJECT_TYPE.SETPLAN.code
    },
    /** 個別カラー設定表示制御 */
    isCabinetSelectedForColor: function () {
      return this.isSpaceSelected && this.opeMode.selectMode === SELECT_MODE.CABINET.code &&
              this.opeMode.selectObject === OBJECT_TYPE.UNIT.code && this.editCtrlSpaces[0].planningType === PLANNING_TYPE.UNIT_SKELTON
    },
    isCombineSelectedForColor: function () {
      return this.isSpaceSelected && this.opeMode.selectMode === SELECT_MODE.CABINET.code &&
              this.opeMode.selectObject === OBJECT_TYPE.UNIT.code && this.editCtrlSpaces[0].planningType === PLANNING_TYPE.COMBINE
    },
    isSetplanSelectedForColor: function () {
      return this.isSpaceSelected && this.opeMode.selectMode === SELECT_MODE.CABINET.code &&
              this.opeMode.selectObject === OBJECT_TYPE.UNIT.code && this.editCtrlSpaces[0].planningType === PLANNING_TYPE.SETPLAN
    },
    isSurfaceSelectedForColor: function () {
      return this.isSpaceSelected && this.opeMode.selectMode === SELECT_MODE.CABINET.code &&
              this.opeMode.selectObject === OBJECT_TYPE.UNIT.code && this.editCtrlSpaces[0].planningType === PLANNING_TYPE.UNIT_SURFACE
    },
    isSetMovingSpace: function () {
      return this.isOneSelected && this.editCtrlSpaces[0].planningType !== PLANNING_TYPE.UNIT_DOOR
    },
    isPtSel: function () {
      let user = App.getUserInfo()
      return user && user.menuServiceCode.ctMenuPtSel && this.isOneUnitSelected
    },
    isKakoDt: function () {
      let user = App.getUserInfo()
      return user && user.menuServiceCode.ctMenuKakoDt
    },
    isPtMove: function () {
      let user = App.getUserInfo()
      return user && user.menuServiceCode.ctMenuPtMove && (this.isOneUnitSelected || this.isOneCombineSelected)
    },
    isSpPrice: function () {
      let user = App.getUserInfo()
      return user && user.menuServiceCode.ctMenuSpPrice
    }
  },
  watch: {
    menuShown: function () {
      if (this.menuShown) {
        document.addEventListener('mousedown', this.onMousedown)
      } else {
        document.removeEventListener('mousedown', this.onMousedown)
      }
    }
  },
  methods: {
    /** メニュ－表示 */
    show: function (position, onCanvas) {
      let element = document.getElementById('context-menu')
      element.style.left = position.x + 'px'
      element.style.top = position.y + 'px'
      // キャンパス外でのメニューは要素がなければ非表示
      this.isContextOnCanvas = onCanvas
      if (!(this.isKakoDt || this.isFocusedParts || this.isFocusedPartsParent) && !this.isContextOnCanvas) return
      this.menuShown = true

      if (this.activeSectionPoint) {
        this.sectionPoint = this.activeSectionPoint
      }
      // 描画完了後に位置調整
      this.$nextTick(function () {
        let elementStyle = element.getBoundingClientRect()
        let clientWidth = document.documentElement.clientWidth
        if (clientWidth < elementStyle.right) {
          element.style.left = (clientWidth - elementStyle.width - 5) + 'px'
        }
        let clientHeight = document.documentElement.clientHeight
        if (clientHeight < elementStyle.bottom) {
          element.style.top = (clientHeight - elementStyle.height - 5) + 'px'
        }
      })
    },
    /** メニュ－非表示 */
    close: function (isClearFocused, event) {
      if (event) {
        // disabledのメニュ押下時は閉じない
        let menu = event.composedPath().find(e => {
          if (!e.classList) return false
          let classList = Array.prototype.slice.call(e.classList)
          if (!classList) return false
          return classList.includes('radio') || classList.includes('checkbox')
        })
        let input = menu ? menu.firstChild : null
        if (input && input.disabled) return
      }
      if (isClearFocused) {
        this.$emit('clearFocusedParts')
      }
      this.menuShown = false
      this.sectionPoint = null
    },
    /** マウス押下時処理 */
    onMousedown: function (event) {
      // コンテキストメニュー外の場合、非表示
      let onContextMenu = event.composedPath().find(e => e.id === 'context-menu')
      if (!onContextMenu) {
        this.close(true)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
#context-menu {
  position: fixed;
  width: auto;
  height: auto;
  padding: 10px;
  background-color: white;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  user-select: none;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  font-size: 0.8em;
  font-weight: bold;
  hr {
    margin: 3px -3px;
  }
  li {
    line-height: 20px;
    &.process {
      cursor: pointer;
      &:hover {
        color: #68C2C3;
      }
      i {
        margin-left: 0px;
        margin-right: 8px;
      }
    }
    &.checkbox, &.radio {
      label {
        display: block;
        position: relative;
        padding-left: 20px;
        cursor: pointer;
        transition: all 0.15s ease;
        text-overflow: ellipsis;
        &:before {
          position: absolute;
          top: 3px;
          left: 0px;
          width: 9px;
          height: 9px;
          content: '';
          border: 0.2em solid #ccc;
          background: #fff;
        }
        &:focus, &:hover {
          color: #68C2C3;
        }
        &:focus:before,
        &:hover:before,
        &:active:before {
          border-color: #68c2c3;
          background: #fff;
        }
      }
      input:checked + label:before {
        border-color: #68c2c3;
        background: #68c2c3;
      }
      // disabled
      input:disabled+label {
        cursor: default;
        color: #ccc;
        &:focus, &:hover {
          color: #ccc;
        }
        &:before,
        &:focus:before,
        &:hover:before,
        &:active:before {
          border-color: #ccc;
        }
      }
      input:checked:disabled+label:before {
        background: #ccc;
      }
    }
    &.checkbox {
      input[type=checkbox] {
        display: none;
      }
    }
    &.radio {
      input[type=radio] {
        display: none;
        padding: .375rem .75rem;
        line-height: 1.5;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/parts/ContextMenu.vue